module.exports = __webpack_public_path__ + "static/img/4.97b6e88.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/eng/4.png
// module id = RPf6
// module chunks = 0